import { useEffect, useState } from 'react';
import { api } from '../../../shared/api/client';

/**
 * Аккаунт ролика из «Монтажа». Ответ /source отдаёт все аккаунты направления,
 * а публиковать нужно в один — свой у ролика. Берём его из задачи; адрес может
 * принести его сам (?montageAccount=), тогда в сеть не ходим.
 */
export function useMontageItemAccount(montageTask: string | null, montageItem: string | null, fromUrl: string | null) {
  const [state, setState] = useState<{ accountId: string | null; resolved: boolean }>(() => ({
    accountId: fromUrl, resolved: !!fromUrl || !(montageTask && montageItem),
  }));
  useEffect(() => {
    if (fromUrl || !montageTask || !montageItem) return;
    let cancelled = false;
    api.get<{ task: { items?: { id: string; accountId?: string | null }[] } }>(`/montage/tasks/${encodeURIComponent(montageTask)}`)
      .then(({ task }) => {
        if (cancelled) return;
        const item = task.items?.find((i) => i.id === montageItem);
        setState({ accountId: item?.accountId ?? null, resolved: true });
      })
      .catch(() => { if (!cancelled) setState({ accountId: null, resolved: true }); });
    return () => { cancelled = true; };
  }, [montageTask, montageItem, fromUrl]);
  return state;
}
